@if (tile(); as tile) {
    <li class="flex flex-col w-[416px] p-4">
        <div class="flex flex-row gap-8 align-items-center">
            <div class="text-[80px] text-bold-green" [class]="tile.icon"></div>
            @if (!isLast()) {
                <hr class="flex-1 border-10 border-t border-red" />
            }
        </div>
        <div class="text-copy-xs text-deep-blue-400">{{ stepPrefix() | translate }} {{ tile.step }}</div>
        <div class="font-bold text-hero-xs-4 !pb-4" [class]="tile.description ? 'pb-4' : ''">
            {{ tile.title | translate }}
        </div>
        <div class="text-copy-xs">
            <div [innerHTML]="tile.description | translate"></div>
            @if (tile.links?.length) {
                <div class="flex flex-col pt-6">
                    @for (link of tile.links; let index = $index; track index) {
                        <div class="py-2">
                            <tran-custom-text-link
                                [url]="link.url"
                                [label]="link.label"
                                [ariaLabel]="link.ariaLabel ?? link.label"
                                [blankTab]="false"
                                [isDownload]="link.isDownload ?? false"
                                [hasIndicator]="true"
                            />
                        </div>
                    }
                </div>
            }
        </div>
    </li>
}
